import PropTypes from 'prop-types';

/**
 *  Creates a function that will pick which icon to use
 *
 * @param {string} name The name of the icon to use
 * @return {JSX.Element} The svg for the icon
 */
const pickIcon = name => {
	switch ( name ) {
		case 'navigation':
			return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
				stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
				<polygon points="3 11 22 2 13 21 11 13 3 11"></polygon>
			</svg>;
		case 'loading':
			return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" fillRule="evenodd"
				strokeLinecap="round" stroke="currentColor" strokeLinejoin="round" strokeWidth="2"
				viewBox="0 0 24 24" className="icon-loading">
				<path
					d="M12 2v3.58m0 12.833v3.58M5.158 5.158L7.69 7.69m8.619 8.619l2.533 2.533M2 12h3.582m12.843 0H22M5.158 18.842L7.69 16.31m8.619-8.619l2.533-2.533" />
			</svg>;
		case 'globe':
			return <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
					stroke="black" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M1 11H21" stroke="black" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M11 1C13.5013 3.73835 14.9228 7.29203 15 11C14.9228 14.708 13.5013 18.2616 11 21C8.49872 18.2616 7.07725 14.708 7 11C7.07725 7.29203 8.49872 3.73835 11 1Z"
					stroke="black" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
			</svg>;
		case 'map-pin':
			return <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M19 10C19 17 10 23 10 23C10 23 1 17 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
					stroke="black" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
					stroke="black" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
			</svg>;
		case 'phone':
			return <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M20.8881 15.9201V18.9201C20.8892 19.1986 20.8322 19.4743 20.7206 19.7294C20.6091 19.9846 20.4454 20.2137 20.2402 20.402C20.035 20.5902 19.7927 20.7336 19.5289 20.8228C19.265 20.912 18.9855 20.9452 18.7081 20.9201C15.631 20.5857 12.6751 19.5342 10.0781 17.8501C7.66194 16.3148 5.61345 14.2663 4.07812 11.8501C2.38809 9.2413 1.33636 6.27109 1.00812 3.1801C0.983127 2.90356 1.01599 2.62486 1.10462 2.36172C1.19324 2.09859 1.33569 1.85679 1.52288 1.65172C1.71008 1.44665 1.93792 1.28281 2.19191 1.17062C2.44589 1.05843 2.72046 1.00036 2.99812 1.0001H5.99812C6.48342 0.995321 6.95391 1.16718 7.32188 1.48363C7.68985 1.80008 7.93019 2.23954 7.99812 2.7201C8.12474 3.68016 8.35957 4.62282 8.69812 5.5301C8.83266 5.88802 8.86178 6.27701 8.78202 6.65098C8.70227 7.02494 8.51698 7.36821 8.24812 7.6401L6.97812 8.9101C8.40167 11.4136 10.4746 13.4865 12.9781 14.9101L14.2481 13.6401C14.52 13.3712 14.8633 13.1859 15.2372 13.1062C15.6112 13.0264 16.0002 13.0556 16.3581 13.1901C17.2654 13.5286 18.2081 13.7635 19.1681 13.8901C19.6539 13.9586 20.0975 14.2033 20.4146 14.5776C20.7318 14.9519 20.9003 15.4297 20.8881 15.9201Z"
					stroke="black" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
			</svg>;
		case 'ac-info':
			return <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path fillRule="evenodd" clipRule="evenodd"
					d="M16 25.8182C21.4224 25.8182 25.8182 21.4224 25.8182 16C25.8182 10.5776 21.4224 6.18182 16 6.18182C10.5776 6.18182 6.18182 10.5776 6.18182 16C6.18182 21.4224 10.5776 25.8182 16 25.8182ZM16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
					fill="#3A3A3C" />
			</svg>;
		case 'email':
			return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" fillRule="evenodd"
				strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24"
				stroke="currentColor">
				<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
				<path d="M22 6l-10 7L2 6" />
			</svg>;
		default:
			throw new Error( 'no SVG for: ' + name );
	}
};

/**
 * Pass the name & fill props (that we will specify in our other components) to Icon to pick the right icon
 *
 * @param {string} name The name of the icon to use
 */
const Icon = ( { name } ) => {
	const SVG = pickIcon( name );
	return SVG;
};

/* set the propTypes so we can catch bugs with typechecking */
Icon.propTypes = {
	name: PropTypes.string.isRequired,
	fill: PropTypes.string,
};

export default Icon;
